import React from 'react'
import type { TemplatesTableColumn } from '@src/components/TemplatesTable'
import Tag from '@src/modules/atoms/tag'
import ActionsButton from '@src/modules/atoms/actions-button'

export const headers = (
  actionsItems: (data: any) => Array<{ title: string; onClick: () => void }>,
  permissions: any
): TemplatesTableColumn[] => [
  {
    title: 'Nombre',
    key: 'title',
    sorteable: true,
    visible: true
  },
  {
    title: 'Espacio de trabajo',
    key: 'workspace_title',
    sorteable: true,
    visible: true
  },
  {
    title: 'Estado',
    key: 'active',
    sorteable: true,
    visible: true,
    render: function (_: any, { active }: any) {
      return <Tag label={active ? 'Activo' : 'Inactivo'} value={active ? 'active' : 'inactive'} />
    }
  },
  {
    title: '',
    key: 'actions',
    align: 'right',
    visible: true,
    render: function (_: any, data: any) {
      if(permissions.update || permissions.destroy) return <ActionsButton items={actionsItems(data)} />
      else return
    }
  }
]
